import { useTranslation } from 'react-i18next';

import { Box } from '@sternum/styled-system';
import { TextInputProps } from '@sternum/ui';
import { Icon } from '@sternum/web/components';
import { namespaces } from '@sternum/web/services/i18n';

import { IconStyled, InputStyled } from './SearchInput.styles';

export interface SearchInputProps extends Omit<TextInputProps, 'onChange' | 'theme'> {
  onChange: (value: string) => unknown;
}

export function SearchInput({ value, onChange, ...props }: SearchInputProps) {
  const { t } = useTranslation(namespaces.appContainerWithMenu);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const clearInput = () => {
    onChange('');
  };

  const ClearIcon = () => {
    return (
      <Box pr={8} onClick={clearInput} role="button" aria-label="Clear icon">
        <Icon type="XIcon" size={12} />
      </Box>
    );
  };

  return (
    <InputStyled
      {...props}
      value={value}
      onChange={handleChange}
      variant="inline"
      leftIcon={<IconStyled type="SearchIcon" color={{ Dark: 'GreyDarker', Light: 'GreyDarker' }} />}
      rightIcon={!!value && <ClearIcon />}
      placeholder={t('dashboardsSearchPlaceholder')}
      width="100%"
      iconHasPointerEvents
    />
  );
}
